import {
    GET_INVOICE_PAYMENT_URL_LOADING,
    GET_INVOICE_PAYMENT_URL_SUCCESS,
    GET_INVOICE_PAYMENT_URL_FAILED,
    REMOVE_INVOICE_PAYMENT_URL
} from "../types";

const initialState = {
    loading: false,
    error: null,
    PaymentUrl: null,
    status: null,
};


export const getInvoicePaymentUrlReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case GET_INVOICE_PAYMENT_URL_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case GET_INVOICE_PAYMENT_URL_SUCCESS:
            return {
                ...state,
                loading: false,
                PaymentUrl: action.payload,
                status: action.status,
                error: null,
            };
        case GET_INVOICE_PAYMENT_URL_FAILED:
            return {
                ...state,
                loading: false,
                PaymentUrl: null,
                status: action.status,
                error: action.error,
            };
        case REMOVE_INVOICE_PAYMENT_URL:
            return initialState;
        default:
            return state;
    }
};




